// Navbar.js

import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';

function Navbar() {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setDropdownVisible((prev) => !prev);
  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link
          to="/"
          aria-label="Go to Home"
          onClick={() => {
            setMobileMenuOpen(false);
            setDropdownVisible(false);
          }}
        >
          <img src={logo} alt="SuShe Logo" />
        </Link>
      </div>

      <button className="hamburger" onClick={toggleMobileMenu}>
        ☰
      </button>

      <div className={`navbar-links ${mobileMenuOpen ? 'active' : ''}`}>
        <Link to="/services" className="nav-btn" onClick={() => setMobileMenuOpen(false)}>Services</Link>
        <Link to="/portfolio" className="nav-btn" onClick={() => setMobileMenuOpen(false)}>Portfolio</Link>

        <div className="dropdown-wrapper" ref={dropdownRef}>
          <button className="nav-btn explore-btn" onClick={toggleDropdown}>
            <span className="btn-text">Explore</span>
            <svg
              className="arrow-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          {dropdownVisible && (
            <ul className="dropdown">
              <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>About Me</Link></li>
              <li><Link to="/handmade-gifts" onClick={() => setMobileMenuOpen(false)}>Handmade Gifts</Link></li>
              <li><Link to="/achievements" onClick={() => setMobileMenuOpen(false)}>Achievements</Link></li>
              <li><Link to="/testimonials" onClick={() => setMobileMenuOpen(false)}>Testimonials</Link></li>
            </ul>
          )}
        </div>

        <Link to="/contact" className="nav-btn" onClick={() => setMobileMenuOpen(false)}>
          <span className="contact-fix">Contact</span>
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
